import { Stack, Typography, Grid } from "@mui/material";
import theme from "@/theme/theme";
import QrCard from "./qrCard";

const READINESS_MOVES = [
    {
        title: "Maintain backwards compatibility",
        description: "Adopt hybrid schemes that combine classical and post-quantum algorithms, so you stay interoperable with partners and suppliers who haven't migrated yet.",
    },
    {
        title: "Adopt new standards where possible",
        description: "No-regret moves are available today: TLS 1.2 to TLS 1.3 migration and enabling ML-KEM key exchange wherever your stack already supports it.",
    },
    {
        title: "Map your crypto dependencies",
        description: "Identify where cryptography lives in your own landscape and across your supply chain, and which critical chains depend on suppliers being ready.",
    },
    {
        title: "Put PQC in procurement",
        description: "The transition is not just an IT project. It spans people, governance and purchasing. Ask suppliers for their roadmaps and put PQC requirements in contracts now.",
    },
];

const QrGap = () => {
    return (
        <Stack
            width={{ xs: "100%", lg: "80%" }}
            marginX="auto"
            paddingX={4}
            gap={6}
            position="relative"
        >
            <Stack gap={2} width={{ xs: "100%", lg: "70%" }}>
                <Typography variant="h3" component="h3" className="chno" fontWeight={400} textTransform="uppercase" fontSize={{ xs: "1.3rem !important", lg: "1.75rem !important" }}>
                    Full compliance isn&apos;t possible yet. Readiness is.
                </Typography>
                <Typography variant="body2" component="p" fontSize="0.95rem !important" color={theme.palette.text.secondary} fontWeight={400}>
                    Even if you wanted to be fully post-quantum today, your suppliers won&apos;t let you.
                    Microsoft plans to be &ldquo;quantum safe enabled&rdquo; by the end of 2029 and to phase out
                    legacy cryptography between 2030 and 2035. Measured against a harvest-now-decrypt-later
                    adversary that is already collecting, that is slow. Most vendor stacks tell a similar story.
                </Typography>
                <Typography variant="body2" component="p" fontSize="0.95rem !important" color={theme.palette.text.secondary} fontWeight={400}>
                    Waiting for the ecosystem to catch up is not a strategy. Organisations that get
                    <strong style={{ color: theme.palette.text.primary }}> ready</strong> now, knowing where
                    their cryptography lives, which chains are critical and which suppliers are the
                    bottleneck, can migrate the moment each dependency unlocks.
                </Typography>
            </Stack>
            <Grid container spacing={3}>
                {READINESS_MOVES.map((move, i) => (
                    // Asymmetric bento: alternating 7/5 spans break the flat 2×2
                    // grid into a diagonal rhythm without making any card "primary".
                    <Grid key={move.title} size={{ xs: 12, sm: 6, lg: i % 3 === 0 ? 7 : 5 }}>
                        <QrCard>
                            <Stack gap={1}>
                                <Typography variant="h6" component="h6" fontWeight={400}>
                                    {move.title}
                                </Typography>
                                <Typography variant="body2" component="p" fontSize="0.85rem !important" color={theme.palette.text.secondary} fontWeight={400}>
                                    {move.description}
                                </Typography>
                            </Stack>
                        </QrCard>
                    </Grid>
                ))}
            </Grid>
        </Stack>
    );
};

export default QrGap;
